import WorkOrderBody from './WorkOrderBody'

export default WorkOrderBody;